import React from 'react';
import TabsBalance from '../Tabs';
import TableResults from '../TableResults';

const ResultList: React.FC = () => {
  return (
    <div style={{ marginTop: '48px' }}>
      <TabsBalance />
      <TableResults />
    </div>
  );
};

export default ResultList;
